<template>
  <div id="pageRoot">
    <p id="tag01" class="textBase basicItem01 tagDefault">FLOR</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">RINCÓN</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">CHIMENEA</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">CAMA</p>

    <p id="question01" class="textBase questionDefault">¿Se esconde en una</p>
    <p id="question0101" class="textBase questionDefault">?</p>

    <p id="question02" class="textBase questionDefault">¿Se metió en un</p>
    <p id="question0202" class="textBase questionDefault">?</p>

    <p id="question03" class="textBase">¿Dónde crees que vive Glo Glo Glo?</p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />

    <!-- SVG ELEMENTS -->
    <img id="flower" src="/pages/img/sordoglo/svgGlo6Flower.svg" />
    <img id="corner" src="/pages/img/sordoglo/svgGlo6Corner.svg" />
    <img id="pencil" src="/pages/img/sordoglo/svgGlo6Pencil.svg" />
  </div>
</template>
<style scoped>
#tag01 {
  position: absolute;
  width: 120px;
  text-align: center;
  left: 27px;
  top: 91px;
}
#tag02 {
  position: absolute;
  width: 150px;
  text-align: center;
  left: 250px;
  top: 91px;
}
#tag03 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 500px;
  top: 91px;
}
#tag04 {
  position: absolute;
  width: 120px;
  text-align: center;
  text-decoration: line-through;
  left: 778px;
  top: 91px;
}

#question01 {
  position: absolute;
  left: 21px;
  top: 278px;
  text-transform: uppercase;
}
#inputField01 {
  position: absolute;
  width: 313px;
  left: 300px;
  top: 262px;
  font-size: 33px;
}
#question0101 {
  position: absolute;
  left: 660px;
  top: 278px;
}
#question02 {
  position: absolute;
  left: 85px;
  top: 448px;
  text-transform: uppercase;
}
#inputField02 {
  position: absolute;
  width: 313px;
  left: 300px;
  top: 435px;
}
#question0202 {
  position: absolute;
  left: 660px;
  top: 448px;
}
#question03 {
  position: absolute;
  left: 118px;
  top: 572px;
  text-transform: uppercase;
}
#inputField03 {
  position: absolute;
  width: 356px;
  left: 350px;
  top: 650px;
}
#pencil {
  position: absolute;
  left: 262px;
  top: 653px;
  transform: rotate(14.21deg);
}
#flower {
  position: absolute;
  left: 717px;
  top: 199px;
}
#corner {
  position: absolute;
  left: 723px;
  top: 422px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 10.mp4", 
        "glo/Video 11b.mp4", 
        "glo/Video 12b.mp4",
        "glo/Video 13.mp4",
        "glo/Video 8.mp4", 
        "glo/Video 9.mp4",
        "glo/Video 14b.mp4"]
    }
  }
}
</script>